module.exports = __webpack_public_path__ + "media/icons/mailing-facebook@2x-0f6d9d86.png";